import { Reducer } from 'react';
import { CLEAR_PRIO_CACHE } from '../../../actions';
import { SET_LAST_PROFILE_LOCATION, LastProfileLocation } from '../actions';

const reducer: Reducer<string, LastProfileLocation> = (
  state = null,
  action
) => {
  switch (action.type) {
    case SET_LAST_PROFILE_LOCATION: {
      return action.profileLocation;
    }
    case CLEAR_PRIO_CACHE: {
      return null;
    }
    default:
      return state;
  }
};

export const getLastProfileLocation = (state: string) => state;

export default reducer;